(function () {
  'use strict';

  var root = document.querySelector('[data-color-finder]');
  if (!root) return;

  var dots = root.querySelectorAll('[data-finder-dot]');
  var panels = root.querySelectorAll('[data-finder-panel]');
  var nameEl = root.querySelector('[data-finder-name]');

  function activate(idx) {
    dots.forEach(function (d) {
      var on = d.getAttribute('data-finder-dot') === String(idx);
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-finder-panel') === String(idx);
      if (on) {
        p.hidden = false;
        if (nameEl) nameEl.textContent = p.getAttribute('data-color-name') || '';
        // restart the pop animation
        p.querySelectorAll('.awita-finder__card').forEach(function (card) {
          card.style.animation = 'none';
          void card.offsetWidth;
          card.style.animation = '';
        });
      } else {
        p.hidden = true;
      }
    });
  }

  root.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-finder-dot]');
    if (!dot) return;
    activate(dot.getAttribute('data-finder-dot'));
  });
})();
